import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentoSolicitudCamViewModel } from '../solicitud-documentacion.types';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';

@Component({
    selector: 'app-solicitud-documentacion-list',
    templateUrl: './solicitud-documentacion-list.component.html',
    styleUrls: ['./solicitud-documentacion-list.component.scss'],
})
export class SolicitudDocumentacionListComponent extends ListBase implements OnInit {
    @Input() documentosSolicitudCam: DocumentoSolicitudCamViewModel[];
    @Input() disabled: boolean;
    @Output() removeDoc = new EventEmitter<DocumentoSolicitudCamViewModel>();
    @Output() undoRemoveDoc = new EventEmitter<DocumentoSolicitudCamViewModel>();
    @Output() editDoc = new EventEmitter<DocumentoSolicitudCamViewModel>();
    @Output() viewDoc = new EventEmitter<DocumentoSolicitudCamViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        this.cols = [
            { field: 'Link', header: '', reduce: true },
            { field: 'Obligatoria', header: 'Obligatoria' },
            { field: 'TipoDocumentacion', header: 'Tipo de Documentación' },
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'NombreArchivo', header: 'Archivo' },
        ];
    }

    trackDocumentacionSolicitudCam(index: number, documentoSolicitudCam: DocumentoSolicitudCamViewModel): number {
        return documentoSolicitudCam?.Id || 0;
    }

    onRemoveDoc(rowData: DocumentoSolicitudCamViewModel): void {
        this.removeDoc.emit(rowData);
    }

    onUndoRemoveDoc(rowData: DocumentoSolicitudCamViewModel): void {
        this.undoRemoveDoc.emit(rowData);
    }

    onEditDoc(rowData: DocumentoSolicitudCamViewModel): void {
        this.editDoc.emit(rowData);
    }

    onViewDoc(rowData: DocumentoSolicitudCamViewModel): void {
        this.viewDoc.emit(rowData);
    }
}
